import moment from 'moment'
export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  userPlatforms: [],
  showActivePlatform: null,
  activePlatform: null,
  token: null,
  globalConfig: null,
  cache: {
    companyList: {
      data: null,
      lastUpdate: null
    },
    clientList: {
      data: null,
      lastUpdate: null
    },
    campaignList: {
    },
    campaignVerticalList: {
      data: null,
      lastUpdate: null
    },
    influencerList: {
      data: null,
      lastUpdate: null
    },
    rateCardList: {
      data: null,
      lastUpdate: null
    }
  },
  userInfo: {
    messages: [{1: 'test', 2: 'test'}],
    notifications: [],
    tasks: []
  },
  aiMatchParams: {
    size: 1000, // default to 100 size
    minFollowers: 500, // default to minimum 500 followers
    postDate: moment().subtract(1, 'years').format('YYYY-MM-DD') // vuetify date picker only accept this format
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js